// removed by extract-text-webpack-plugin
module.exports = {"layout":"src-display-modules-Home-Workbench3-index__layout--1QOaM","sider":"src-display-modules-Home-Workbench3-index__sider--2_xFb","header":"src-display-modules-Home-Workbench3-index__header--1Clc7","content":"src-display-modules-Home-Workbench3-index__content--lulfg","mL245":"src-display-modules-Home-Workbench3-index__mL245--2H3mj","appBox":"src-display-modules-Home-Workbench3-index__appBox--2XW9k","appBoxLong":"src-display-modules-Home-Workbench3-index__appBoxLong--2SoO5"};


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/Workbench3/index.scss
// module id = 6806
// module chunks = 0